import React from "react";
import { RuleItem } from "../../interfaces/RuleItem";
import { BonusFromSource } from "../../interfaces/BonusFromSource";
import DataTable from "./DataTable";

export default function RuleItemDataTable(props: { ruleItems: RuleItem[] }) {
  const itemKeys: string[] = [];
  const sourceMap: { [key: string]: Set<string> } = {};
  const sources: Set<string> = new Set();
  props.ruleItems.forEach((item: RuleItem) => {
    itemKeys.push(item.key);
    if (item.details.bonusCalculator) {
      item.details.bonusCalculator.sources.forEach(
        (source: BonusFromSource) => {
          sources.add(source.source);
          if (item.key in sourceMap) {
            sourceMap[item.key].add(source.source);
          } else {
            sourceMap[item.key] = new Set<string>().add(source.source);
          }
        }
      );
    }
  });
  return (
    <DataTable itemKeys={itemKeys} sourceMap={sourceMap} sources={sources} />
  );
}
